import { render, staticRenderFns } from "./TgSwitchBtn.vue?vue&type=template&id=1c0c46aa"
import script from "./TgSwitchBtn.vue?vue&type=script&lang=js"
export * from "./TgSwitchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports